import { MenuItemInterface } from 'utils/types/oraclePayment/MenuItem';
import { useTranslation } from 'react-i18next';
import { CollapseButton, MenuCollapse } from './index.view';
import { HorizontalLine } from '../../index.view';
import MenuItem from '../MenuItem';
import useViewModel from './viewModel';
interface MenuListProps {
  menuItems: MenuItemInterface[];
  isCheckLimitItem?: boolean;
}

const MenuList = ({ menuItems, isCheckLimitItem }: MenuListProps) => {
  const { t } = useTranslation();
  const { showLessItemAmount, setShowLessItemAmount, limit, getMenuItems } = useViewModel({
    menuItems,
  });

  const getLessItems = () => {
    return menuItems.map((item, index) => (
      <>
        {index !== 0 && <HorizontalLine size={0.5} border="dashed" />}
        <MenuItem key={index} menuItem={item} />
      </>
    ));
  };

  const getMoreItems = () => {
    return (
      <>
        {getMenuItems(true).map((item, index) => (
          <MenuItem key={index} menuItem={item} />
        ))}
        <MenuCollapse in={showLessItemAmount} timeout="auto" unmountOnExit>
          {getMenuItems(false).map((item, index) => (
            <MenuItem key={index} menuItem={item} />
          ))}
        </MenuCollapse>
        <CollapseButton onClick={() => setShowLessItemAmount(!showLessItemAmount)}>
          {showLessItemAmount ? t('lessDetail') : t('moreDetail')}
        </CollapseButton>
      </>
    );
  };

  const getFullItems = () => {
    return menuItems.map((item, key) => <MenuItem key={key} menuItem={item} />);
  };

  return (
    <>
      {' '}
      {isCheckLimitItem
        ? menuItems.length <= limit
          ? getLessItems()
          : getMoreItems()
        : getFullItems()}{' '}
    </>
  );
};

export default MenuList;
